import { DataSourceLabel, ExtraId } from '@/common/apis/dtos';
import { ExtraIdItem } from './ExtraIdItem';
import { Theme, useMediaQuery, styled, Box } from '@mui/material';

const ExtraIdListContainer = styled(Box)<{ isMobile?: boolean }>(({ theme, isMobile }) => ({
  display: 'grid',
  gridColumnGap: '1.8em',
  gridRowGap: '0px',
  padding: '0 1rem',
  marginLeft: '5px',
  minWidth: 0, // Allow grid items to shrink
  ...(isMobile
    ? {
        gridTemplateRows: 'repeat(4, minmax(0, 1fr))',
        gridAutoFlow: 'column',
        overflowX: 'auto', // Allow horizontal scrolling if needed
        '& > *': {
          minWidth: 0, // Ensure grid items can shrink
        }
      }
    : {
        gridTemplateRows: '1fr',
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        gridAutoFlow: 'row',
      }),
}));

export interface ExtraIdListProps {
  extraIds: { [key: string]: ExtraId[] };
  tenantDataSourceLabels?: DataSourceLabel[];
  selectedTenant: string;
}

export const ExtraIdList = ({ extraIds, selectedTenant, tenantDataSourceLabels }: ExtraIdListProps) => {
  const positions = [1, 2, 3, 4];

  const isMobileScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  return (
    <>
      {Object.keys(extraIds)
        .filter((key) => key === selectedTenant)
        .map((key) => {
          const extraIdValues = positions.map((position) =>
            extraIds[key].find((value) => value.position === position),
          );

          return (
            <ExtraIdListContainer
              key={key}
              isMobile={isMobileScreen}
            >
              {extraIdValues.map((value) => {
                const matchedLabel = value?.dataSource
                  ? tenantDataSourceLabels?.find(
                      (dsl) => dsl.dataSource === value.dataSource
                    )
                  : undefined;

                return (
                  <ExtraIdItem
                    key={value?.dataSource} // fallback in case dataSource is undefined
                    value={value}
                    dataSourceLabel={matchedLabel}
                  />
                );
              })}
            </ExtraIdListContainer>
          );
        })}
    </>
  );
};
